import { render, staticRenderFns } from "./WebshopProductSlider.vue?vue&type=template&id=5a85bdae&scoped=true&"
import script from "./WebshopProductSlider.vue?vue&type=script&lang=js&"
export * from "./WebshopProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./WebshopProductSlider.vue?vue&type=style&index=0&id=5a85bdae&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85bdae",
  null
  
)

export default component.exports